import { section } from "framer-motion/client";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { Banner, PrivacyPolicyImage } from "../images";
import { useState, useEffect } from "react";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const termsofService = [
  {
    title: "Introduction",
    section:
      "Your privacy is important to us. This Privacy Policy explains how TechProjects collects, uses, and protects personal information when you use our website or Services.",
  },
  {
    title: "Information We Collect",
    section: "We may collect the following types of data:",
    bullets: [
      "Personal Information: Name, email, phone number, organization, and job title.",
      "Usage Data: IP address, browser type, operating system, and activity on our website.",
      "Cookies: We use cookies and similar technologies to improve user experience and analytics.",
    ],
  },
  {
    title: "How We Use Information",
    section: "We use your information to:",
    bullets: [
      "Provide and improve our Services.",
      "Respond to inquiries and support requests.",
      "Send updates, offers, or marketing materials (with your consent).",
      "Maintain security and prevent fraudulent activities.",
    ],
  },
  {
    title: "Sharing of Information",
    section:
      "We do not sell your personal data. We may share information only:",
    bullets: [
      "With trusted service providers who assist in operating our business.",
      "To comply with legal obligations or enforce our rights.",
      "During a merger, acquisition, or sale of assets.",
    ],
  },
  {
    title: "Data Security",
    section:
      "We implement technical and organizational measures to safeguard your personal information against unauthorized access, alteration, disclosure, or destruction.",
  },
  {
    title: "Data Retention",
    section:
      "We retain your personal information only as long as necessary to fulfill the purposes described above, or as required by law.",
  },
  {
    title: "Your Rights",
    section:
      "Depending on your jurisdiction, you may have rights to access, correct, delete, or restrict processing of your personal information. You can exercise these rights by contacting us",
  },
];

function PrivacyPolicy() {
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);
  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[460px]">
          <img
            src={Banner}
            alt="Banner"
            className="absolute inset-0 -z-10 md:h-full h-[calc(100vh-0px)] w-full object-cover"
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-[56rem] font-roboto space-y-6 mt-16">
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Privacy Policy
              </h1>
              <p className="text-md text-[#404040]">
                Effective Date: October 24, 2025
              </p>
            </div>

            <div className="max-w-xl flex justify-end mt-16">
              <img
                src={PrivacyPolicyImage}
                alt="image"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
        <section className="py-20 bg-white px-6 md:px-10 font-roboto">
          <div className="max-w-3xl mx-auto py-8 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <ul className="flex flex-col gap-4">
              {termsofService?.map((item, idx) => (
                <li className="text-[#0F172A] font-bold text-2xl list-decimal">
                  {item?.title} <br />
                  <p className="font-400 text-lg text-[#323232] mt-4">
                    {item?.section}
                  </p>
                  {termsofService[idx]?.bullets?.length > 0 && (
                    <ul className="space-y-2 font-400 text-lg ml-8 mt-4 text-[#0F172A]">
                      {termsofService[idx].bullets.map((b, i) => (
                        <li key={i} className="list-disc">
                          {b}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default PrivacyPolicy;
